import script from "./MListaChips.vue?vue&type=script&lang=ts&setup=true"
export * from "./MListaChips.vue?vue&type=script&lang=ts&setup=true"

import "./MListaChips.vue?vue&type=style&index=0&id=a470e572&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a470e572"]])

export default __exports__